import { useMutation } from 'react-query';

import { deleteRiskRegister as mutationFn } from 'api/endPoints/deleteRiskRegister';

export const useMutationDeleteRiskRegister = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    riskId: number[];
}
